/* lua.js generated code undefined */

let Event = require("cocos/framework/components/event")
let UserTagBase = xClass("UserTagBase", Event)
UserTagBaseEvent = table([1, "StoreData", "USERTAGBASEEVENT.STOREDATA"])
UserTagBase.prototype.ctor = function () {
    let self = this
    self.bind(self)
    if (type(self.init) === "function") {
        self.init()
    }
}
UserTagBase.prototype.needStoreData = function () {
    let self = this
    self.dispatchEvent(table([1, "name", UserTagBaseEvent.StoreData]))
}
module.exports = table([0, UserTagBase], [0, UserTagBaseEvent])
